import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

export type QuickEvaluationContext =
  | 'pipelineCard'
  | 'formField'
  | 'profileThumbs'
  | 'hiddenEvaluations';

@Injectable()
export class QuickEvaluationsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Evaluations';
  public readonly requireViewContext = true;

  public trackQuickEvaluate(trigger: QuickEvaluationContext) {
    this.track('QuickEvaluate', { trigger });
  }
}
